import { gql } from "@apollo/client";

export const DeleteCarousel = gql`
mutation DeleteCarousel($deleteCarouselId: ID!) {
  deleteCarousel(id: $deleteCarouselId) {
    status
  }
}
`;
